const footballs = [
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc01.jpg",
    },
   
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc5.JPG",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc7.JPG",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc8.JPG",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc9.jpeg",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs.png",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs2.jpg",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs2.jpg",
    },

    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs3.jpg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc10.jpeg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc11.jpeg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc12.jpeg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc13.jpg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc14.jpg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc15.jpeg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc16.jpg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc17.jpg",
    },   {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc18.jpg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc19.JPG",
    },

    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc20.JPG",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc21.JPG",
    }, 
   
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc22.jpg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc23.jpg",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc24.jpg",
    },
     
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs4.jpg",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs5.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs6.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs7.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs8.JPG",
    }, 
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc1.JPG",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc3.JPG",
    },
    {
      title : 'comcamp',
      thumbnailUrl :"./picture/comcamp/cc4.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs9.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs10.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs12.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs13.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs14.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs15.JPG",
    }, 
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs16.JPG",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs17.jpg",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs18.jpg",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs19.jpg",
    },
    {
      title : 'cs',
      thumbnailUrl :"./picture/cskmitl/cs20.jpg",
    },
    {
      title : 'daily',
      thumbnailUrl :"./picture/daily/d1.jpg",
    },
    {
      title : 'daily',
      thumbnailUrl :"./picture/daily/d2.jpg",
    },
    {
      title : 'daily',
      thumbnailUrl :"./picture/daily/d3.png",
    },
    {
      title : 'daily',
      thumbnailUrl :"./picture/daily/d4.jpg",
    },
    {
      title : 'kaset',
      thumbnailUrl :"./picture/kaset/kaset1.jpg",
    },
    {
      title : 'kaset',
      thumbnailUrl :"./picture/kaset/kaset2.jpg",
    },
    {
      title : 'kaset',
      thumbnailUrl :"./picture/kaset/kaset3.jpg",
    },
    {
      title : 'kaset',
      thumbnailUrl :"./picture/kaset/kaset4.jpg",
    },
    {
      title : 'kaset',
      thumbnailUrl :"./picture/kaset/kaset5.jpg",
    },
    {
      title : 'music',
      thumbnailUrl :"./picture/music/m1.jpg",
    },
    {
      title : 'music',
      thumbnailUrl :"./picture/music/m2.jpg",
    },
    {
      title : 'music',
      thumbnailUrl :"./picture/music/m3.jpg",
    },
    {
      title : 'music',
      thumbnailUrl :"./picture/music/m4.jpg",
    },

   


    
  ];
  export default footballs;